import * as mutationTypes from 'store/mutationTypes'

/**
 * @return {Promise}
 */
export const setConfigEventId = function ({ commit }, evetnId) {
  return commit(mutationTypes.SET_CONFIG_EVENT_ID, evetnId)
}

/**
 * @return {Promise}
 */
export const setConfigAttributionId = function ({ commit }, attributionId) {
  return commit(mutationTypes.SET_CONFIG_ATTRIBUTION_ID, attributionId)
}

/**
 * @return {Promise}
 */
export const setConfigClient = function ({ commit }, client) {
  return commit(mutationTypes.SET_CONFIG_CLIENT, client)
}

/**
 * @return {Promise}
 */
export const setConfigAffiliateId = function ({ commit }, affiliateId) {
  return commit(mutationTypes.SET_CONFIG_AFFILIATE_ID, affiliateId)
}

/**
 * @return {Promise}
 */
export const setConfigTrackingId = function ({ commit }, trackingId) {
  return commit(mutationTypes.SET_CONFIG_TRACKING_ID, trackingId)
}



// WEBPACK FOOTER //
// ./src/store/modules/config/actions.js